<template>
  <span>

    <v-img
        :src="fileUrl"
        class="grey lighten-2 my-2"
        height="100"
        style="margin: 0 auto;"
        v-if="fileUrl && showImage"
        width="100"/>
    <span v-else>
    </span>
          <v-file-input :label="label" :placeholder="placeholder" :rules="formRules" @change="onFilePicked"
                        outlined show-size
                        ref="inputRef"
                        v-model="innerValue"/>
  </span>
</template>

<script>
    const valid_files = ["png", "jpeg", "jpg", "pdf", "docx"];
    const image_files = ["png", "jpeg", "jpg"];
    export default {

        data: () => ({
            selectedFileName: false,
            innerValue: null,
            dialog: false,
            fileUrl: null,
            valid_files,
            image_files,
            rules: {
                fileRequired: value => {
                    let message = "Required";
                    if (value) {
                        if (value.name !== undefined)
                            message = true;
                    }
                    return message;
                }
            },
        }),
        props: {
            valid: {
                type: Boolean,
                value: true,
                default: true
            },
            showImage: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            value: {
                type: null
            },
            required: {
                type: Boolean,
                default: false
            },
            imageUrl: {
                type: String,
                default: null
            },
            valid_file_types: {
                type: Array,
                default: () => valid_files
            },
            fileSize: {
                type: Number,
                default: 512
            },
        },
        computed: {
            formRules() {
                let rules = [];
                if (this.required) {
                    rules = [this.rules.fileRequired]
                }
                return rules;
            }
        },
        methods: {
            showFilePicker() {
                this.$refs.filePicker.click();
            },
            onFilePicked(e) {
                if (typeof e !== "undefined") {
                    let file = e;
                    if (file) {
                        if (file.name) {
                            let fileName = file.name;
                            let extension = fileName.split(".").pop();
                            if (!this.valid_file_types.includes(extension)) {
                                this.$refs.inputRef.reset();
                                this.$store.commit(
                                    "Notification/showError",
                                    "Please upload a valid file type"
                                );
                            } else {
                              let fileSize = this.fileSize;
                              let sizeName = "KB";
                                if ((file.size / 1000) > fileSize) {
                                  if(fileSize > 1000) {
                                    fileSize = Math.floor(fileSize/1000);
                                    sizeName = "MB"
                                  }
                                    this.$refs.inputRef.reset();
                                    this.$store.commit(
                                        "Notification/showError",
                                        `File Too Large. Size should be less than ${fileSize} ${sizeName}`
                                    );
                                } else {
                                    const fileReader = new FileReader();
                                    fileReader.readAsDataURL(file);
                                    fileReader.addEventListener("load", () => {
                                        if (this.showImage && image_files.includes(extension)) {
                                            this.fileUrl = fileReader.result;
                                        }
                                        this.$emit('input', file)
                                    });
                                    this.selectedFileName = fileName;
                                }
                            }
                        }
                    }
                }
                this.fileUrl = null;

            },
        },
        watch: {
            innerValue(new_value) {
                if (new_value === null) {
                    this.fileUrl = null;
                }
                this.$emit('input', new_value)
            },
            value(new_value) {
                if (new_value === null) {
                    this.fileUrl = null;
                }
                this.innerValue = new_value
            },
            imageUrl(new_value) {
                this.fileUrl = new_value;
            }
        },
        mounted() {
            if (this.imageUrl) {
                this.fileUrl = this.imageUrl;
            }
        }
    }
    ;
</script>
